import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './FooterCfgLogoSection.module.css';

const FooterCfgLogoSection: React.FC = () => {
  return (
    <div className={styles.cfgLogoSection}>
      <a
        href='https://www.cfa.go.jp/'
        target='_blank'
        rel='noopener noreferrer'
      >
        <StaticImage
          src='../../../../static/img/cfg.png'
          alt='こども家庭庁'
          className={styles.logo}
          imgClassName={styles.logo}
          objectFit='contain'
          imgStyle={{ objectFit: 'contain' }}
          placeholder='blurred'
        />
      </a>
      <small className={styles.copyright}>
        Copyright © Children and Families Agency, All Rights reserved.
      </small>
    </div>
  );
};

export default FooterCfgLogoSection;
